import axios from 'axios'
import { storeAllEntities } from '@/helpers/store'

const getDefaultSubscribableGroupingState = () => {
  return {
    subscribableGroupings: {},
  }
}

export default {
  state: getDefaultSubscribableGroupingState,
  mutations: {
    RESET_SUBSCRIBABLE_GROUPING_STATE (state) {
      Object.assign(state, getDefaultSubscribableGroupingState())
    },
  },
  actions: {
    resetSubscribableGroupingState ({ commit, state }) {
      commit('RESET_SUBSCRIBABLE_GROUPING_STATE')
    },
    getSubscribableGroupingSubscribables ({ commit, state }, { subscribableGroupingId }) {
      return axios.get(`/employee/subscribable-groupings/${subscribableGroupingId}/subscribables/api`)
    },
    getSubscribableGroupingSubscriptions ({ commit, state }, { subscribableGroupingId }) {
      return axios.get(`/employee/subscribable-groupings/${subscribableGroupingId}/subscriptions/matrix-overview/api`).then(storeAllEntities(commit))
    },
  },
  getters: {},
}
